import { ErrorResolutionActions } from '../app/common/errorResolution/errorResolutionActions.tsx';
import { loginActionTypes } from './login.constants';
import * as loginServices from './login.services';

export const loginActions = {
    getMember,
    reset,
};

function getMember() {
    return (dispatch, getState) => {
        dispatch(request());
        const data = {
            currency: getState().app.clientConfig.currency,
        };
        loginServices
            .getMemberInfo(data)
            .then((res) => {
                dispatch(success(res, false));
            })
            .catch((errorResolution) => {
                dispatch(ErrorResolutionActions.processErrorResolution(errorResolution));
                dispatch(failure());
            });
    };

    function request() {
        return { type: loginActionTypes.GET_MEMBER_REQUEST };
    }

    function success(user, redirect) {
        return { type: loginActionTypes.GET_MEMBER_SUCCESS, user, redirect };
    }

    function failure() {
        return { type: loginActionTypes.GET_MEMBER_FAILURE };
    }
}

function reset() {
    return {
        type: loginActionTypes.RESET,
    };
}
